/**
 * @generated SignedSource<<71829e5a86436fad5b703acfa0450d20>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ResolutionModalQuery$variables = {
  slug: string;
  platformCompanyId?: string | null;
  reportId: string;
  resolutionId: string;
};
export type ResolutionModalQuery$data = {
  readonly organizationBySlug: {
    readonly integrationItems: {
      readonly nodes: ReadonlyArray<{
        readonly data: any;
      }>;
    };
    readonly integrationAccounts: {
      readonly nodes: ReadonlyArray<{
        readonly data: any;
      }>;
    };
    readonly integrationCustomers: {
      readonly nodes: ReadonlyArray<{
        readonly data: any;
      }>;
    };
    readonly integrationVendors: {
      readonly nodes: ReadonlyArray<{
        readonly data: any;
      }>;
    };
  } | null;
  readonly reportById: {
    readonly " $fragmentSpreads": FragmentRefs<"RelatedTransactionsTable_report">;
  } | null;
  readonly reportResolutionById: {
    readonly id: string;
    readonly currentValue: any | null;
    readonly initialValue: any | null;
    readonly resolutionKind: string | null;
    readonly status: string | null;
    readonly updateStatus: string | null;
    readonly anomalyTypes: ReadonlyArray<any | null> | null;
    readonly responseData: any | null;
  } | null;
};
export type ResolutionModalQuery = {
  variables: ResolutionModalQuery$variables;
  response: ResolutionModalQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "platformCompanyId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "reportId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "resolutionId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "slug"
},
v4 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "slug"
  }
],
v5 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "platformCompanyId",
        "variableName": "platformCompanyId"
      }
    ],
    "kind": "ObjectValue",
    "name": "condition"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "data",
  "storageKey": null
},
v7 = [
  (v6/*: any*/)
],
v8 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "reportId"
  }
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currentValue",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "initialValue",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "resolutionKind",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "anomalyTypes",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "resolutionId"
    }
  ],
  "concreteType": "ReportResolution",
  "kind": "LinkedField",
  "name": "reportResolutionById",
  "plural": false,
  "selections": [
    (v9/*: any*/),
    (v10/*: any*/),
    (v11/*: any*/),
    (v12/*: any*/),
    (v13/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updateStatus",
      "storageKey": null
    },
    (v14/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "responseData",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v16 = [
  (v6/*: any*/),
  (v9/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ResolutionModalQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "Organization",
        "kind": "LinkedField",
        "name": "organizationBySlug",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v5/*: any*/),
            "concreteType": "IntegrationItemsConnection",
            "kind": "LinkedField",
            "name": "integrationItems",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "IntegrationItem",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": (v7/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v5/*: any*/),
            "concreteType": "IntegrationAccountsConnection",
            "kind": "LinkedField",
            "name": "integrationAccounts",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "IntegrationAccount",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": (v7/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v5/*: any*/),
            "concreteType": "IntegrationCustomersConnection",
            "kind": "LinkedField",
            "name": "integrationCustomers",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "IntegrationCustomer",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": (v7/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v5/*: any*/),
            "concreteType": "IntegrationVendorsConnection",
            "kind": "LinkedField",
            "name": "integrationVendors",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "IntegrationVendor",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": (v7/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v8/*: any*/),
        "concreteType": "Report",
        "kind": "LinkedField",
        "name": "reportById",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "RelatedTransactionsTable_report"
          }
        ],
        "storageKey": null
      },
      (v15/*: any*/)
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "ResolutionModalQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "Organization",
        "kind": "LinkedField",
        "name": "organizationBySlug",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v5/*: any*/),
            "concreteType": "IntegrationItemsConnection",
            "kind": "LinkedField",
            "name": "integrationItems",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "IntegrationItem",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": (v16/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v5/*: any*/),
            "concreteType": "IntegrationAccountsConnection",
            "kind": "LinkedField",
            "name": "integrationAccounts",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "IntegrationAccount",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": (v16/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v5/*: any*/),
            "concreteType": "IntegrationCustomersConnection",
            "kind": "LinkedField",
            "name": "integrationCustomers",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "IntegrationCustomer",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": (v16/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v5/*: any*/),
            "concreteType": "IntegrationVendorsConnection",
            "kind": "LinkedField",
            "name": "integrationVendors",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "IntegrationVendor",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": (v16/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v9/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v8/*: any*/),
        "concreteType": "Report",
        "kind": "LinkedField",
        "name": "reportById",
        "plural": false,
        "selections": [
          (v9/*: any*/),
          {
            "alias": null,
            "args": [
              {
                "fields": [
                  {
                    "kind": "Literal",
                    "name": "anomalies",
                    "value": []
                  },
                  {
                    "kind": "Literal",
                    "name": "transactionData",
                    "value": null
                  }
                ],
                "kind": "ObjectValue",
                "name": "input"
              }
            ],
            "concreteType": "ReportResolutionsConnection",
            "kind": "LinkedField",
            "name": "filteredReportResolutions",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ReportResolution",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v14/*: any*/),
                  (v13/*: any*/),
                  (v12/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": "filteredReportResolutions(input:{\"anomalies\":[],\"transactionData\":null})"
          }
        ],
        "storageKey": null
      },
      (v15/*: any*/)
    ]
  },
  "params": {
    "cacheID": "7eadc8786267e3995011de6e7321b6dc",
    "id": null,
    "metadata": {},
    "name": "ResolutionModalQuery",
    "operationKind": "query",
    "text": "query ResolutionModalQuery(\n  $slug: String!\n  $platformCompanyId: String\n  $reportId: ID!\n  $resolutionId: ID!\n) {\n  organizationBySlug(slug: $slug) {\n    integrationItems(condition: {platformCompanyId: $platformCompanyId}) {\n      nodes {\n        data\n        id\n      }\n    }\n    integrationAccounts(condition: {platformCompanyId: $platformCompanyId}) {\n      nodes {\n        data\n        id\n      }\n    }\n    integrationCustomers(condition: {platformCompanyId: $platformCompanyId}) {\n      nodes {\n        data\n        id\n      }\n    }\n    integrationVendors(condition: {platformCompanyId: $platformCompanyId}) {\n      nodes {\n        data\n        id\n      }\n    }\n    id\n  }\n  reportById(id: $reportId) {\n    ...RelatedTransactionsTable_report\n    id\n  }\n  reportResolutionById(id: $resolutionId) {\n    id\n    currentValue\n    initialValue\n    resolutionKind\n    status\n    updateStatus\n    anomalyTypes\n    responseData\n  }\n}\n\nfragment RelatedTransactionsTable_report on Report {\n  id\n  filteredReportResolutions(input: {anomalies: []}) {\n    nodes {\n      id\n      currentValue\n      initialValue\n      anomalyTypes\n      status\n      resolutionKind\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3a0956e65b418d12ba8711614e82f0dd";

export default node;
